import { makeStyles } from '@mui/styles';
import { BLACK, ERROR, GAINSBORO, GHOST_WHITE, NEON_BLUE_LIGHT, SHAMROCK, TUTU, } from '@returnmates/client-core/src/constants/colors';
import { POPPINS } from '../../constants/styles/fonts';
var useStyles = makeStyles(function () { return ({
    textField: {
        margin: '0 auto',
        '& label': {
            backgroundColor: GHOST_WHITE,
            padding: '0 2px',
        },
    },
    input: {
        '&:hover': {
            border: function (_a) {
                var variant = _a.variant;
                return variant === 'secondary' ? "2px solid ".concat(BLACK) : "2px solid ".concat(NEON_BLUE_LIGHT);
            },
        },
        '&.Mui-focused': {
            border: function (_a) {
                var variant = _a.variant;
                return variant === 'secondary' ? "2px solid ".concat(BLACK) : "2px solid ".concat(NEON_BLUE_LIGHT);
            },
        },
    },
    inputError: {
        backgroundColor: TUTU,
    },
    noBorder: {
        border: 0,
    },
    errorHandler: {
        position: 'relative',
        fontFamily: POPPINS,
        fontSize: 14,
        color: ERROR,
    },
    successHandler: {
        position: 'relative',
        fontFamily: POPPINS,
        fontSize: 14,
        color: SHAMROCK,
    },
    outlined: {},
    beforeIcon: {
        backgroundColor: 'transparent',
        position: 'relative',
        height: 'calc(100% + 2px)',
        padding: '10px 14px',
        marginTop: -1,
        marginBottom: -1,
        borderRadius: 3,
    },
    border: {
        position: 'absolute',
        width: '100%',
        height: 'calc(100% + 4px)',
        left: 0,
        top: -2,
        borderRadius: 3,
        borderRight: "1px solid ".concat(GAINSBORO),
    },
    inputNotchedOutline: {
        border: 0,
    },
    inputSuccessOutline: {
        border: "2px solid ".concat(SHAMROCK, " !important"),
    },
    multiline: {
        height: '100%',
    },
    copyIcon: {
        cursor: 'pointer',
        opacity: 0.4,
        minWidth: 20,
        minHeight: 20,
        marginLeft: 5,
        marginTop: 7,
        '&:hover': {
            opacity: 1,
        },
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
    },
}); });
export default useStyles;
//# sourceMappingURL=styles.js.map